import 'bootstrap/dist/css/bootstrap.min.css';
import { Card } from 'primereact/card';
import './App.css';
//theme
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/lara-light-indigo/theme.css";
//core
import { createClient } from "@supabase/supabase-js";
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import "primereact/resources/primereact.min.css";
import { useEffect, useState } from 'react';



function App() {
  
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [currentState, setCurrentState] = useState(0); // 0 loading, 1 invalid code, 2 form, 3 ok, 4 failed
  const [accessToken, setAccessToken] = useState(undefined);
  const anonToken = process.env.REACT_APP_ANON;
  const [params, setParams] = useState();
  const [isEmailConfirm, setIsEmailConfirm] = useState(false);

  const changePassword = (password) => {
    const supabase = createClient(process.env.REACT_APP_URL, anonToken);
    supabase.auth.updateUser({ password: password }).then((change) => {
      if(change) {
        setCurrentState(3);
      } else {
        setCurrentState(4);
      }
    });

  }

  useEffect(() => {
    var accessToken = undefined;
    setCurrentState(0);
    const hash = window.location.hash;
    if (hash) {
      console.log("Hash has changed", hash);

      let parametersKeys = new Map();

      const hashParameters = hash.split('#')[1].split('&');
      for (const param of hashParameters) {
        const paramArgs = param.split('=');
        const key = paramArgs[0];
        const value = paramArgs[1];
        parametersKeys.set(key, value);
        console.log(key, value)
      }


      accessToken = parametersKeys.get('access_token');
      const type = parametersKeys.get('type');

      console.log("type", type);

      setIsEmailConfirm(type === "signup")

      if (accessToken != undefined) {
        localStorage.setItem("token",accessToken)
        setAccessToken(accessToken)
      }
    }

    setCurrentState(accessToken ? 2 : 1)
  }, [])
  
  const updatePasswordField = (e) => {
    setPassword(e.target.value)
  }

  const updateRePasswordField = (e) => {
    setRePassword(e.target.value)
  }

  const completeChange = () => {
    changePassword(password);
  }
  const renderChangeForm = () => {
    return (
      <>
        <div className='bold' style={{ fontSize: "1.3rem" }}>Cambio de contraseña</div>
        <div className='p-2'>
          <div className='my-2'>
            <span className="p-input-icon-left w-100">
              <i className="pi pi-lock" />
              <InputText className='w-100' type='password' value={password} onChange={updatePasswordField} placeholder="Nueva contraseña" />
            </span>
          </div>

          <div className='my-2'>
            <span className="p-input-icon-left mt-4 mb-2 w-100">
              <i className="pi pi-lock" />
              <InputText type="password" className="w-100" value={rePassword} onChange={updateRePasswordField} placeholder="Repetir contraseña" />
            </span>
          </div>


          {
            password.length > 0 && rePassword.length > 0 && password !== rePassword ? (<div>
              <small className='red'>Las contraseñas deben coincidir</small>
            </div>) : undefined
          }
          <div className='mt-2 pt-2'>
            <Button className='w-100' label="Aceptar" disabled={!(password.length > 0 && rePassword.length > 0 && password === rePassword)} onClick={completeChange} />
          </div>
        </div>
      </>
    )
  }

  const renderInvalidAccess = () => {
    return (
      <>
        <i className="pi pi-sync red" style={{ fontSize: '2rem' }} />
        <div className='pt-2'>
        <h2 className='red'>El enlace ha caducado</h2><div><h6>Vuelve a solicitar que te enviemos un nuevo correo</h6></div>
        </div>
      </>
    )
  }
  
  const renderChangePasswordCorrectly = () => {
    return (
      <>
        <i className="pi pi-check-circle green" style={{ fontSize: '2rem' }} />
        <div className='pt-2'>
        <h2 className='green'>La contraseña ha sido modificada correctamente</h2><div><h6>Haz login en la app</h6></div>
        </div>
      </>
    )
  }

  const renderChangePasswordFailed = () => { //pi-times
    return (
      <>
        <i className="pi pi-times-circle red" style={{ fontSize: '2rem' }} />
        <div className='pt-2'>
        <h2 className='red'>Ha ocurrido un error</h2><div><h6>Inténtalo más tarde</h6></div>
        </div>
      </>
    )
  }

  const renderEmailSignupCorrectly = () => {
    return (
      <>
        <i className="pi pi-check-circle green" style={{ fontSize: '2rem' }} />
        <div className='pt-2'>
        <h2 className='green'>Has verificado correctamente tu cuenta</h2><div><h6>Ya puedes regresar a la app</h6></div>
        </div>
      </>
    )
  }

  const renderRecovery = () => {
    let render = undefined;
    switch (currentState) {
      case 0: // Loading
        render = <>cargando</>
        break;

      case 1:
        render = renderInvalidAccess();
        break;

      case 2:
        render = renderChangeForm();
        break;
      
      case 3:
        render = renderChangePasswordCorrectly();
        break;

      case 4:
        render = renderChangePasswordFailed();
        break;
    }

    return render;
  }


  const renderEmailSignup = () => {
    return renderEmailSignupCorrectly();
  }

  return (
    <div className="App w-100 h-100" style={{ position: "absolute", backgroundColor: "#81ac47" }}>
      <div className='container h-100'>
        <div className='row h-100'>
          <div className="col-5 p-4 mx-auto my-auto" style={{
            minWidth: 352
          }}>
            <Card>
              <div className='p-4'>
                {isEmailConfirm ? renderEmailSignup():renderRecovery()}
              </div>

            </Card>
          </div>
        </div>
      </div>

    </div>
  );
}

export default App;
